import script from "./ModalOrderUploadTutorial.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalOrderUploadTutorial.vue?vue&type=script&setup=true&lang=ts"

import "./ModalOrderUploadTutorial.vue?vue&type=style&index=0&id=5e7fb99b&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e7fb99b"]])

export default __exports__